import {React} from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import DashboardPage from "../pages/DashboardPage/DashboardPage";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getPermissionsAsync } from "../../features/redux/sessionSlice";
import AdminDashboardPage from "../pages/AdminDashboardPage/AdminDashboardPage";


function AppRouter() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getPermissionsAsync())
    },[])
    return (
        <Routes>
            <Route path={'admin-dashboard'} element={<AdminDashboardPage/>} />
            <Route path={'dashboard'} element={<DashboardPage/>} />
            <Route path="*" element={<Navigate to={'dashboard'}/>} />
        </Routes>
    )
}

export default AppRouter;